module.exports = __webpack_public_path__ + "static/media/aayush.a6090df0.jpg";